import styled from 'styled-components'
import { rem } from 'polished'
import { useAppSelector } from 'hooks/reduxHooks'
import { useHasSiteFooter } from '../../consent/useHasSiteFooter'
import { useCookieSettingsLinkVisible } from '../../consent/useCookieSettingsLinkVisible'
import CookieSettingsLink from './CookieSettingsLink'

const CookieSettingsHeaderBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: ${rem(8)} ${rem(16)};
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
`

function CookieSettingsHeaderAccess() {
  const headless = useAppSelector(state => state.system.headlessMode)
  const hasFooter = useHasSiteFooter()
  const isVisible = useCookieSettingsLinkVisible()

  if (!isVisible || (hasFooter && !headless)) return undefined

  return (
    <CookieSettingsHeaderBar>
      <CookieSettingsLink variant="header" />
    </CookieSettingsHeaderBar>
  )
}

export default CookieSettingsHeaderAccess
